module.exports = __webpack_public_path__ + "static/media/iphone.e7254f97.png";